import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  Observable,
  ApolloClientOptions,
} from "@apollo/client";
import { GRAPHQL_URL, REPO_VERSION, API_KEY } from "@/env";

type Metadata = import("grpc-web").Metadata; // type only import

const getClient = (
  restHeaders: Metadata,
  otherOptions: ApolloClientOptions<any>,
  uri = GRAPHQL_URL
) => {
  const request = (operation: any) => {
    return operation.setContext({
      headers: restHeaders,
    });
  };

  const requestLink = new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        let handle: any;
        Promise.resolve(operation)
          .then((oper) => request(oper))
          .then(() => {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            });
          })
          .catch(observer.error.bind(observer));

        return () => {
          if (handle) handle.unsubscribe();
        };
      })
  );

  const httpLink = new HttpLink({
    uri,
    headers: {
      "x-api-key": API_KEY,
    },
  });

  return new ApolloClient({
    link: ApolloLink.from([requestLink, httpLink]),
    name: "consumer-web-app",
    version: REPO_VERSION,
    ssrForceFetchDelay: 100,
    ...otherOptions,
  });
};

export default getClient;
